import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import qctoLogo from "../../images/qcto.png";
import dhetLogo from "../../images/DHET-Logo.png";
import logo from "../../images/imageNewLogo.png";
import TPCUnifiedBackdrop from "../../homePage/productPageModern/TPCUnifiedBackdrop";
const TIKTOK_SVG = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="24" fill="#000"/><path d="M33.2 18.7c-1.9-.1-3.6-.9-4.7-2.2-.9-1-1.4-2.3-1.5-3.7h-3.8v17.4c0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8c.4 0 .8.1 1.2.2v-3.9c-.4-.1-.8-.1-1.2-.1-4.2 0-7.6 3.4-7.6 7.6s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6V23c1.6 1.1 3.5 1.8 5.5 1.8h.7v-3.8c-.7 0-1.4-.1-2-.3z" fill="#fff"/></svg>`)}`;

const socialLinks = [
  {
    href: "https://www.facebook.com/TPCPerformanceCentre",
    src: "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2F10464408.png?alt=media",
    alt: "Facebook",
  },
  {
    href: "https://www.instagram.com/tpcperformancecentre/",
    src: "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Finsta.png?alt=media",
    alt: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/107660745/admin/dashboard/",
    src: "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Flinked.png?alt=media",
    alt: "LinkedIn",
  },
  {
    href: "https://whatsapp.com",
    src: "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Fwhatsapp.png?alt=media",
    alt: "WhatsApp",
  },
  {
    href: "https://x.com/TPCpta",
    src: "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2F10464257.png?alt=media",
    alt: "X (Twitter)",
  },
  {
    href: "https://www.tiktok.com/@techperformancecentre?_r=1&_t=ZS-93cMfGLf673",
    src: TIKTOK_SVG,
    alt: "TikTok",
  },
];

const TikTokIcon = () => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="tiktok-svg"
  >
    <circle cx="24" cy="24" r="24" fill="#000" />
    <path
      d="M34.1 19.3c-2.1 0-4-.7-5.5-1.9v8.7c0 4.3-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9 3.5-7.9 7.9-7.9c.4 0 .9 0 1.3.1v3.9c-.4-.1-.9-.2-1.3-.2-2.2 0-3.9 1.8-3.9 3.9s1.8 3.9 3.9 3.9c2.2 0 4-1.7 4-3.9V10h3.8c.3 2.8 2.5 5 5.3 5.4v3.9h.3z"
      fill="#fff"
    />
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [fullName, setFullName] = useState("");
  const [programme, setProgramme] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setSubmitStatus(null);

    const to = "registrations@tpc.training;Helena@tpc.training";
    const subject = `TPC enquiry: ${programme || "General enquiry"}`;

    const textBody = `Full name: ${fullName}\nEmail: ${email}\nProgramme of interest: ${programme}`;

    try {
      const sendEmail = httpsCallable(functions, "sendEmail");
      const payload = {
        to,
        from: `Enquiry <noreply@mail.andus.co.za>`,
        subject,
        isHTML: false,
        text: textBody,
      };

      const result = await sendEmail(payload);

      if (result && result.data && result.data.success) {
        setSubmitStatus("Message sent — we will be in touch shortly.");
        setFullName("");
        setProgramme("");
        setEmail("");
        setMessage("");
      } else {
        setSubmitStatus("Failed to send message. Please try again later.");
      }
    } catch (err) {
      console.error("Error sending email:", err);
      setSubmitStatus("An error occurred while sending. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  const scrollToPrograms = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const programsSection = document.getElementById("programs-section");
        if (programsSection) {
          programsSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 500);
    } else {
      const programsSection = document.getElementById("programs-section");
      if (programsSection) {
        programsSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <TPCUnifiedBackdrop>
      <footer className="footer-container sleek-footer">
        <div className="footer-top">
          <div className="footer-columns">
            <div className="footer-column">
              <h3 className="footer-column-heading">Programmes</h3>
              <ul className="footer-links">
                <li>
                  <a href="/programs/softwareDeveloper" className="white-text">
                    Software Developer Learning Path
                  </a>
                </li>
                <li>
                  <a href="/programs/AIDeveloper" className="white-text">
                    AI developer & data science learning path
                  </a>
                </li>
                <li>
                  <a href="/programs/cyber-security" className="white-text">
                    Cyber Security learning path
                  </a>
                </li>
              </ul>
              <hr className="footer-divider" />
              <h3 className="footer-column-heading">Corporate Training</h3>
              <ul className="footer-links">
                <li>
                  <a href="/programs/AITools" className="white-text">
                    AI in the workplace
                  </a>
                </li>
                <li>
                  <a
                    href="/corporate-training/ethical-ai"
                    className="white-text"
                  >
                    Cyber security in the age of AI
                  </a>
                </li>
              </ul>
              <br />
              <img
                src={logo}
                alt="TPC Logo"
                className="mobile-programs-logo-image"
              />
            </div>

            <div className="footer-column">
              <h3 className="footer-column-heading">Legal and Compliance</h3>
              <ul className="footer-links">
                <li>
                  <button
                    className="footer-scroll-link"
                    onClick={scrollToPrograms}
                  >
                    <a
                      href="https://popia.co.za/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      POPI Act
                    </a>
                  </button>
                </li>
                <li>
                  <button
                    className="footer-scroll-link"
                    onClick={scrollToPrograms}
                  >
                    <a href="https://techperformancecentre.com/terms-and-conditions">
                      {" "}
                      Terms & Conditions
                    </a>
                  </button>
                </li>
              </ul>
              <h3 className="footer-column-heading">
                More About Tech Performance Centre
              </h3>

              <ul className="footer-links">
                <li>
                  <a href="/about" className="white-text">
                    About Us
                  </a>
                </li>
                <br />
                <h3
                  className="footer-column-heading"
                  style={{ fontSize: "16px" }}
                >
                  Accreditation and Compliance
                </h3>
                <hr className="footer-divider" />
                <li>
                  <div className="accreditation-text">
                    <p style={{ fontSize: "16px" }}>
                      Full registration with Department of Higher Education
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      Registration number: 2009/FET07/088
                    </p>
                  </div>
                </li>
                <hr className="footer-divider" />
                <li>
                  <div className="accreditation-text">
                    <p style={{ fontSize: "16px" }}>
                      Full accreditation with QCTO 
                    </p>
                    <p style={{ fontSize: "16px" }}>
                      Accreditation Number: 2006/021703/07
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="footer-column contact-column">
              <h3
                className="footer-column-heading"
                style={{ fontSize: "24px" }}
              >
                Contact us
              </h3>
              <ul className="footer-links contact-list">
                <li className="contact-item">
                  <span
                    className="contact-icon"
                    aria-hidden
                    style={{ fontSize: "16px" }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.6 10.8c1.9 3.7 5.2 6 8.9 7.9l1.9-1.9c.3-.3.7-.4 1.1-.3 1.2.3 2.4.5 3.7.5.6 0 1 .4 1 1V22c0 .6-.4 1-1 1C9.8 23 1 14.2 1 3c0-.6.4-1 1-1h3.3c.6 0 1 .4 1 1 0 1.3.2 2.6.5 3.8.1.4 0 .8-.3 1.1L6.6 10.8z"
                        fill="currentColor"
                      />
                    </svg>
                    <span style={{ paddingLeft: "5px" }}>
                      Campus Contact Details:
                    </span>
                  </span>
                  <div className="contact-text">
                    <a className="contact-value" href="tel:+27120513483">
                      012 051 3483
                    </a>
                    <hr className="footerDividerContact" />
                  </div>
                </li>

                <li className="contact-item">
                  <span
                    className="contact-icon"
                    aria-hidden
                    style={{ fontSize: "16px" }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.6 10.8c1.9 3.7 5.2 6 8.9 7.9l1.9-1.9c.3-.3.7-.4 1.1-.3 1.2.3 2.4.5 3.7.5.6 0 1 .4 1 1V22c0 .6-.4 1-1 1C9.8 23 1 14.2 1 3c0-.6.4-1 1-1h3.3c.6 0 1 .4 1 1 0 1.3.2 2.6.5 3.8.1.4 0 .8-.3 1.1L6.6 10.8z"
                        fill="currentColor"
                      />
                    </svg>
                    <span style={{ paddingLeft: "5px" }}>Student Support:</span>
                  </span>
                  <div className="contact-text">
                    <a className="contact-value" href="tel:+27646282114">
                      +27 64 628 2114
                    </a>
                    <hr className="footerDividerContact" />
                  </div>
                </li>

                <li className="contact-item">
                  <span
                    className="contact-icon"
                    aria-hidden
                    style={{ fontSize: "16px" }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                        fill="currentColor"
                      />
                    </svg>
                    <span style={{ paddingLeft: "5px" }}> Location:</span>
                  </span>
                  <div className="contact-text">
                    <span className="contact-value">
                      Floor 2, Landmark Building, 13 Umgazi Rd, Menlo Park,
                      Pretoria, 0081
                    </span>
                  </div>
                  <hr className="footerDividerContact" />
                </li>
                <li className="contact-item">
                  <span
                    className="contact-icon"
                    aria-hidden
                    style={{ fontSize: "16px" }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                        fill="currentColor"
                      />
                    </svg>
                    <span style={{ paddingLeft: "5px" }}> Email:</span>
                  </span>
                  <div className="contact-text">
                    <a
                      className="contact-value"
                      href="mailto:info@tpc.training"
                    >
                      info@tpc.training
                    </a>
                    <hr className="footerDividerContact" />
                  </div>
                </li>
              </ul>
              <h3 className="footer-column-heading">Send Us an email</h3>

              <form className="footer-contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="input-group">
                    <label className="small-label">FULL NAME</label>
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Your name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-group">
                    <label className="small-label">EMAIL ADDRESS</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-row single">
                  <div className="input-group">
                    <label className="small-label">PROGRAMME OF INTEREST</label>
                    <select
                      name="programme"
                      value={programme}
                      onChange={(e) => setProgramme(e.target.value)}
                      required
                    >
                      <option value="">Select a programme</option>
                      <option value="bootcamp">Bootcamps</option>
                      <option value="career-boosters">Career Boosters</option>
                      <option value="full-programs">Full Programs</option>
                      <option value="code-curious">Code Curious?</option>
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  className="footer-btn"
                  disabled={isSending}
                >
                  {isSending ? "Sending..." : "Send Email"}
                </button>
                {submitStatus && (
                  <p
                    className="footer-submit-status"
                    style={{ marginTop: "10px", color: "#d9d9d9" }}
                  >
                    {submitStatus}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="footer-social-center">
          {socialLinks.map((s, i) => {
            const iconClass =
              s.alt === "TikTok"
                ? "futuristic-social-icon tiktok-icon"
                : "futuristic-social-icon";

            return (
              <a
                key={i}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className={iconClass}
              >
                <img src={s.src} alt={s.alt} />
              </a>
            );
          })}
        </div>

        <div className="footer-bottom">
          <p>© Tech Performance Centre. All rights reserved.</p>
        </div>
      </footer>
    </TPCUnifiedBackdrop>
  );
};

export default Footer;
